var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEasyWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.216,
    height: 74.357,
    viewBox: "0 0 48.216 74.357",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "easy",
    transform: "translate(-51.483 -10.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10836",
    "data-name": "Group 10836",
    transform: "translate(51.483 10.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10835",
    "data-name": "Group 10835"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_908",
    "data-name": "Path 908",
    className: "cls-1",
    d: "M90.2,10.211c-.77.455-.735.945.245,4.8a15.634,15.634,0,0,0,1.3,3.921,1.434,1.434,0,0,0,2.241-1.085,36.454,36.454,0,0,0-.875-3.851c-.665-2.521-.945-3.4-1.3-3.641A1.322,1.322,0,0,0,90.2,10.211Z",
    transform: "translate(-77.751 -10.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_909",
    "data-name": "Path 909",
    className: "cls-1",
    d: "M125.441,10.29c-.245.175-.665,1.435-1.3,3.921-.525,2.031-.945,3.781-.945,3.851a1.736,1.736,0,0,0,.49.63,1.319,1.319,0,0,0,1.926.105,42.222,42.222,0,0,0,2.066-7.492A1.5,1.5,0,0,0,125.441,10.29Z",
    transform: "translate(-100.833 -10.046)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_910",
    "data-name": "Path 910",
    className: "cls-1",
    d: "M56.619,42.938c-.98,1.26-.455,1.75,3.816,3.571,3.291,1.435,3.361,1.435,3.851,1.12a1.4,1.4,0,0,0,.63-1.82c-.21-.385-.945-.805-3.466-1.926C57.879,42.273,57.214,42.168,56.619,42.938Z",
    transform: "translate(-54.547 -31.105)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_911",
    "data-name": "Path 911",
    className: "cls-1",
    d: "M147.558,43.67c-3.571,1.575-3.991,1.926-3.536,3.011a1.66,1.66,0,0,0,.735.805c.42.21.875.07,3.746-1.155,4.131-1.785,4.131-1.785,4.131-2.731a1.228,1.228,0,0,0-1.3-1.4C151.024,42.27,149.343,42.9,147.558,43.67Z",
    transform: "translate(-115.395 -30.927)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_912",
    "data-name": "Path 912",
    className: "cls-1",
    d: "M69.29,53.864a4.494,4.494,0,0,0-2.93,2c-1.04,1.566-1.071,2-1.071,13.267V79.385l-.41-.092a27.964,27.964,0,0,0-5.671-.8c-2.9,0-4.506.522-5.986,1.966a5.571,5.571,0,0,0-1.733,4.3,4.06,4.06,0,0,0,.536,2.488,8.154,8.154,0,0,0,4.253,3.87c.945.43,2.332,1.075,3.088,1.443,3.466,1.689,6.4,5.006,6.932,7.954.095.553.977,3.532,1.922,6.6l1.733,5.559,11.878.061,11.878.031,1.008-6.3c.536-3.47,1.1-6.7,1.2-7.156a37.1,37.1,0,0,1,2.048-5.682,20.518,20.518,0,0,0,1.7-9.643c-.221-3.685-.662-5.651-1.733-7.586-.945-1.751-2.237-2.518-4.726-2.856-1.008-.123-1.134-.215-2.363-1.351a8.291,8.291,0,0,0-8.255-2.211c-.63.154-.725.123-1.355-.369a3.935,3.935,0,0,0-2.993-.983L77.23,68.7l-.032-.614c-.032-.338-.063-2.764-.126-5.405-.095-4.791-.095-4.791-.6-5.835A5.6,5.6,0,0,0,73.8,54.109,9.891,9.891,0,0,0,69.29,53.864Zm3.529,2.825a2.3,2.3,0,0,1,.977.983c.347.645.378,1.106.5,7.463.095,3.716.189,6.787.221,6.818a5.852,5.852,0,0,0,1.323-.307,10.471,10.471,0,0,1,1.827-.338,5.2,5.2,0,0,1,2.836,1.382l.693.676,1.229-.461a6.231,6.231,0,0,1,2.458-.461c1.764-.031,2.8.491,4.537,2.242l1.386,1.382,1.418.123a8.331,8.331,0,0,1,1.953.338c1.733.706,2.615,3.655,2.615,8.753a14.047,14.047,0,0,1-1.2,6.726c-2.079,4.822-2.395,5.927-3.371,12.039-.347,2.211-.725,4.484-.819,5.006l-.189.983H72l-1.386-4.515c-.756-2.457-1.481-5.006-1.607-5.682-.882-4.177-4.978-8.538-9.767-10.38-3.4-1.351-4.632-2.4-5.01-4.3a3.471,3.471,0,0,1,2.678-3.747c2.237-.461,4.821-.184,8.6.983,1.26.4,2.332.706,2.395.706S68,77.7,68,71.062c0-12.868.032-13.329.851-14.066A4.715,4.715,0,0,1,72.819,56.689Z",
    transform: "translate(-51.483 -38.411)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_913",
    "data-name": "Path 913",
    className: "cls-1",
    d: "M62.849,78.787a34.8,34.8,0,0,0-3.571,1.47c-.77.63-.105,2.381.91,2.381a28.476,28.476,0,0,0,3.641-1.19c3.536-1.3,4.271-1.785,4.026-2.7-.175-.735-.665-1.19-1.26-1.155A22,22,0,0,0,62.849,78.787Z",
    transform: "translate(-56.331 -56.452)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_914",
    "data-name": "Path 914",
    className: "cls-1",
    d: "M141.476,77.99a1.342,1.342,0,0,0-.14,1.715,41.138,41.138,0,0,0,7.492,2.871,1.691,1.691,0,0,0,1.26-1.435,1.436,1.436,0,0,0-.245-.77,41.777,41.777,0,0,0-7.457-2.871A1.257,1.257,0,0,0,141.476,77.99Z",
    transform: "translate(-113.488 -56.388)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasyWhite);
export default __webpack_public_path__ + "static/media/easy-white.76dd673ba9cbf9a1da81e10de7c3484d.svg";
export { ForwardRef as ReactComponent };